import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import * as React from 'react';

/*
 * development announcement tooltip
 * Import this component in parent component.
 * Children must be included.
 */

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip sx={{ display: 'block' }} {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#EF6B39',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    padding: '0.6rem 0.85714rem',
    borderRadius: '0.57142rem',
    fontSize: '0.95rem',
    background: 'linear-gradient(to bottom, #ff8c3f, #de4832)',
  },
  zIndex: 100,
}));

const FreeAnnouncementTooltip = (props: FunnelTooltipProps) => {
  const [message, setMessage] = React.useState<string | JSX.Element>('');
  const [childrenRendered, setChildrenRendered] = React.useState(false);
  const containerRef = React.useRef<HTMLSpanElement>(null);
  const popperRef = React.useRef<any>(null);

  React.useEffect(() => {
    if (props.text == 'memno') {
      setMessage(
        <div>
          출결 체크 시 입력할 번호를 기입하세요.{' '}
          <div style={{ fontSize: '0.925rem', color: '#febeac', paddingTop: '0.15rem' }}>
            • 학부모님 번호 뒷 4자리 추천
          </div>{' '}
          <div style={{ fontSize: '0.925rem', color: '#febeac' }}>• 다자녀는 1,2를 붙여 5자리로 구분</div>{' '}
        </div>,
      );
    } else {
      setMessage(props.text);
    }
  }, [props.text]);

  React.useEffect(() => {
    if (containerRef.current) {
      const timer = setTimeout(() => {
        setChildrenRendered(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [props.children]);

  React.useEffect(() => {
    if (props.updateTrigger !== undefined && popperRef.current && typeof popperRef.current.update === 'function') {
      const timer = setTimeout(() => {
        popperRef.current.update();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [props.updateTrigger]);

  return (
    <BootstrapTooltip
      title={message}
      placement={props.placement}
      arrow
      open={props.isOpen && childrenRendered}
      PopperProps={{
        popperRef: popperRef,
      }}
      {...(props.sx && { sx: props.sx })}
    >
      <span ref={containerRef} className='free-announcement-children' style={{ width: 'auto' }}>
        {props.children}
      </span>
    </BootstrapTooltip>
  );
};

FreeAnnouncementTooltip.defaultProps = {
  isOpen: true,
  placement: 'left',
  text: 'props 로 text를 입력해주세요.',
  zIndex: 100,
};

export default FreeAnnouncementTooltip;
